import { type PropsWithChildren, useRef } from 'react';

import { createStore, type Store } from '../../../../../core/store/store.js';
import { AnnotationsStateContext } from '../contexts/AnnotationsStateContext.js';
import { type AnnotationState } from '../types/state.js';
import { initialState } from './AnnotationsDataInitialState.js';

export const AnnotationsStoreProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  const storeRef = useRef<Store<AnnotationState> | null>(null);

  storeRef.current ??= createStore(initialState);

  return (
    <AnnotationsStateContext.Provider value={storeRef.current}>
      {children}
    </AnnotationsStateContext.Provider>
  );
};
